import React, { useEffect }  from "react";
import "../css/home.css";
// import "./CarouselComponent.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { Carousel } from "bootstrap";



// Product Data
const allProducts = [
  { id: 1, image: "/kids.jpg", category: "Kids" },
  { id: 2, image: "/baby.jpg", category: "Baby" },
  { id: 3, image: "/boy.jpg", category: "Boys" },
  { id: 4, image: "/girls.jpg", category: "Girls" },
];

// Product Card Component
const ProductCard = ({ product }) => {
  return (
    <div className="product-item">
      <div className="product">
        <img src={product.image} alt={product.category} />
      </div>
      <div className="category-label">
        {product.category.charAt(0).toUpperCase() + product.category.slice(1)}
      </div>
    </div>
  );
};

// Home Component
const Home = () => {
  
  useEffect(() => {
  const carouselElement = document.querySelector("#bs-carousel");
  const instance = Carousel.getOrCreateInstance(carouselElement);

  const interval = setInterval(() => {
    instance.next();
  }, 3000);

  return () => clearInterval(interval);
}, []);


  return (
    <div>
      {/* Carousel */}
      <div
        id="bs-carousel"
        className="carousel slide"
        data-bs-ride="carousel"
        data-bs-interval="3000"
      >
        <div className="overlay"></div>

        {/* Indicators */}
        <div className="carousel-indicators">
          <button
            type="button"
            data-bs-target="#bs-carousel"
            data-bs-slide-to="0"
            className="active"
            aria-current="true"
          ></button>
          <button
            type="button"
            data-bs-target="#bs-carousel"
            data-bs-slide-to="1"
          ></button>
          <button
            type="button"
            data-bs-target="#bs-carousel"
            data-bs-slide-to="2"
          ></button>
        </div>

        {/* Slides */}
        <div className="carousel-inner">
          <div className="carousel-item active">
            <div className="slide-1"></div>
            <div className="hero">
              <hgroup>
                <h1>Welcome to H&H Fashion</h1>
                <h3> </h3>
              </hgroup>
            </div>
          </div>

          <div className="carousel-item">
            <div className="slide-2"></div>
            <div className="hero">
              <hgroup>
                <h1>Welcome to H&H Fashion</h1>
              </hgroup>
            </div>
          </div>

          <div className="carousel-item">
            <div className="slide-3"></div>
            <div className="hero">
              <hgroup>
                <h1>Welcome to H&H Fashion</h1>
              </hgroup>
            </div>
          </div>
        </div>

        {/* Controls */}
        <button
          className="carousel-control-prev"
          type="button"
          data-bs-target="#bs-carousel"
          data-bs-slide="prev"
        >
          <span
            className="carousel-control-prev-icon"
            aria-hidden="true"
          ></span>
          <span className="visually-hidden">Previous</span>
        </button>
        <button
          className="carousel-control-next"
          type="button"
          data-bs-target="#bs-carousel"
          data-bs-slide="next"
        >
          <span
            className="carousel-control-next-icon"
            aria-hidden="true"
          ></span>
          <span className="visually-hidden">Next</span>
        </button>
      </div>

      {/* Product Grid */}
      <div className="container-fluid bg-white mt-5 " id="pro">
        <h2>Categories</h2><br></br>
        <div className="product-grid">
          {allProducts.map((product) => (
            <ProductCard key={product.id} product={product} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Home;
